const SecurityServices = (securityInstance) => {
  const login = (val) => securityInstance.post(`/users/login`, val);
  // const register = (val) => securityInstance.post(`/signup/trixie`, val);
  const register = (val) => securityInstance.post(`/early-adopters`, val);
  const verifyAccount = (val) => securityInstance.get(`/verify-account`, val);
  const changePassword = ({
    userId,
    currentPassword,
    newPassword,
  }: {
    userId: string;
    currentPassword: string;
    newPassword: string;
  }) => {
    return securityInstance.put("/change-password", {
      userId,
      password: currentPassword,
      newPassword,
    });
  };

  return {
    login,
    register,
    verifyAccount,
    changePassword,
  };
};
export default SecurityServices;
